"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _jwtDecode2 = _interopRequireDefault(require("jwt-decode"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Offer = _interopRequireDefault(require("../../components/Offer"));
var _ErrorPage = _interopRequireDefault(require("../../components/ErrorPage"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _Footer = _interopRequireDefault(require("../../components/Footer"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _api = require("../../api");
var _appConfigHelper = require("../../util/appConfigHelper");
var _reactRedux = require("react-redux");
var _toolkit = require("@reduxjs/toolkit");
var _offerSlice = require("../../redux/offerSlice");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _orderSlice = require("../../redux/orderSlice");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _withPaymentFinalizationHandler = _interopRequireDefault(require("../withPaymentFinalizationHandler"));
var _StyledOfferContainer = require("./StyledOfferContainer");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var OfferContainer = function OfferContainer(_ref) {
  var offerIdProp = _ref.offerId,
    adyenConfigurationProp = _ref.adyenConfiguration,
    onSuccess = _ref.onSuccess;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    errorMsg = _useState2[0],
    setErrorMsg = _useState2[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.publisherConfig;
    }),
    offerIdStore = _useSelector.offerId,
    adyenConfigurationStore = _useSelector.adyenConfiguration;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.order;
    }),
    order = _useSelector2.order,
    isOrderLoading = _useSelector2.loading,
    orderError = _useSelector2.error;
  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
      return state.offer;
    }),
    offerError = _useSelector3.error;
  var offerId = offerIdProp || offerIdStore;
  var adyenConfiguration = adyenConfigurationProp || adyenConfigurationStore;
  var freeOfferPaymentMethodHandler = function freeOfferPaymentMethodHandler(orderId) {
    (0, _api.getPaymentMethods)().then(function (paymentMethodResponse) {
      var paymentMethods = paymentMethodResponse.responseData.paymentMethods;
      var properPaymentMethodId = paymentMethods.find(function (method) {
        return (0, _appConfigHelper.getData)('CLEENG_OFFER_TYPE') === 'S' ? method.methodName === 'manual' : method.methodName !== 'manual';
      });
      if (properPaymentMethodId) {
        (0, _api.updateOrder)(orderId, {
          paymentMethodId: properPaymentMethodId.id
        });
      }
    });
  };
  var createOrderHandler = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(longOfferId) {
      var resultOrderAction, _unwrapResult, id, totalPrice, applied;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch((0, _orderSlice.fetchCreateOrder)(longOfferId));
          case 2:
            resultOrderAction = _context.sent;
            _unwrapResult = (0, _toolkit.unwrapResult)(resultOrderAction), id = _unwrapResult.id, totalPrice = _unwrapResult.totalPrice, applied = _unwrapResult.discount.applied;
            if (totalPrice === 0 && !applied) {
              freeOfferPaymentMethodHandler(id);
              dispatch((0, _offerSlice.setFreeOffer)(true));
            }
            (0, _appConfigHelper.setData)('CLEENG_ORDER_ID', id);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function createOrderHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var reuseSavedOrder = function reuseSavedOrder(id, longOfferId) {
    dispatch((0, _orderSlice.fetchGetOrder)(id)).unwrap().then(function (orderResponse) {
      var _jwtDecode = (0, _jwtDecode2.default)((0, _appConfigHelper.getData)('CLEENG_AUTH_TOKEN')),
        customerId = _jwtDecode.customerId;
      if (!(orderResponse.offerId === longOfferId && orderResponse.customerId === customerId)) {
        (0, _appConfigHelper.removeData)('CLEENG_ORDER_ID');
        createOrderHandler(longOfferId);
      }
    }).catch(function () {
      (0, _appConfigHelper.removeData)('CLEENG_ORDER_ID');
      createOrderHandler(longOfferId);
    });
  };
  var onCouponSubmit = function onCouponSubmit(couponCode) {
    if (couponCode === '') return;
    dispatch((0, _orderSlice.fetchUpdateCoupon)({
      id: order.id,
      couponCode: couponCode
    })).then(function () {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_COUPON_SUCCESSFUL, {
        detail: {
          coupon: couponCode,
          source: 'checkout'
        }
      });
    }).catch(function () {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_COUPON_FAILED, {
        detail: {
          coupon: couponCode,
          source: 'checkout'
        }
      });
    });
  };
  (0, _react.useEffect)(function () {
    dispatch((0, _publisherConfigSlice.init)({
      offerId: offerId,
      adyenConfiguration: adyenConfiguration
    }));
    if (!offerId) {
      setErrorMsg('Offer not set');
      return;
    }
    var init = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var resultOfferAction, _unwrapResult2, id, orderId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch((0, _offerSlice.fetchOffer)(offerId));
            case 2:
              resultOfferAction = _context2.sent;
              _unwrapResult2 = (0, _toolkit.unwrapResult)(resultOfferAction), id = _unwrapResult2.offerId;
              (0, _appConfigHelper.setData)('CLEENG_OFFER_ID', id);
              (0, _appConfigHelper.setData)('CLEENG_OFFER_TYPE', id.charAt(0));
              orderId = (0, _appConfigHelper.getData)('CLEENG_ORDER_ID');
              if (!orderId) {
                _context2.next = 11;
                break;
              }
              reuseSavedOrder(orderId, id);
              _context2.next = 13;
              break;
            case 11:
              _context2.next = 13;
              return createOrderHandler(id);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function init() {
        return _ref3.apply(this, arguments);
      };
    }();
    init();
    if (offerId === '' && !(0, _appConfigHelper.getData)('CLEENG_OFFER_ID')) {
      setErrorMsg('Offer not set');
    }
  }, [offerIdProp]);
  (0, _react.useEffect)(function () {
    if (!isOrderLoading || errorMsg || offerError || orderError) {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_LOADED);
    }
  }, [isOrderLoading, errorMsg, offerError, offerError]);
  var errorMapping = function errorMapping(err) {
    var errorTypes = {
      cannotPurchase: ['Offer is blocked for country'],
      offerNotExist: ["doesn't exist", 'does not exist', 'Invalid param offerId', 'Offer not set'],
      alreadyHaveAccess: ['Access already granted'],
      generalError: ['Request failed with status code 500'],
      inactive: ['inactive']
    };
    var types = Object.keys(errorTypes);
    return types.find(function (type) {
      return errorTypes[type].find(function (item) {
        return item.includes(err) || err.includes(item);
      });
    });
  };
  if (errorMsg || offerError || orderError) {
    return /*#__PURE__*/_react.default.createElement(_ErrorPage.default, {
      type: errorMapping(errorMsg || offerError || orderError)
    });
  }
  if (isOrderLoading) {
    return /*#__PURE__*/_react.default.createElement(_StyledOfferContainer.StyledLoaderContainer, null, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_StyledOfferContainer.StyledLoaderContent, null, /*#__PURE__*/_react.default.createElement(_Loader.default, null)), /*#__PURE__*/_react.default.createElement(_Footer.default, null));
  }
  return /*#__PURE__*/_react.default.createElement(_Offer.default, {
    couponProps: _objectSpread(_objectSpread({}, order.couponDetails), {}, {
      onSubmit: onCouponSubmit
    }),
    onPaymentComplete: onSuccess
  });
};
OfferContainer.propTypes = {
  onSuccess: _propTypes.default.func,
  urlProps: _propTypes.default.shape({
    location: _propTypes.default.shape({
      search: _propTypes.default.string
    })
  }),
  offerId: _propTypes.default.string,
  adyenConfiguration: _propTypes.default.objectOf(_propTypes.default.any)
};
OfferContainer.defaultProps = {
  onSuccess: function onSuccess() {},
  urlProps: {},
  offerId: '',
  adyenConfiguration: null
};
var _default = (0, _withPaymentFinalizationHandler.default)(OfferContainer);
exports.default = _default;